import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import styled from "styled-components";
import logo from '../resources/Vista Logos/logo-transparent-png.png';
import YouthBg from '../resources/youth_bg.svg';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf'; 
import GreyBox from '../resources/grey-box2.svg';
import Myth from '../resources/myth-image.svg';
import BarChartHorizontalComp from "../Charts/BarChartHorizontal";
import LadyWithDrink from '../resources/lady_with_drink.png';
import Web from '../resources/website.svg';
import Phone from '../resources/phone.svg';
import SOSIcon from '../resources/sos-icon.svg';
import Location from '../resources/location.svg';
import downloadImg from '../resources/Download.png';
import Car from '../resources/car.svg';
import EndImage from '../resources/end-image.svg';
import TopImage from '../resources/response_car.svg';
import Loader from '../components/Loader';



const MIMetrics2 = () => {
    const history = useNavigate();
    const [isVisible, setIsVisible] = useState(false);
    const divRef = useRef(null);
    let [sample2Data, setSample2Data] = React.useState({});
    let studentResponses = JSON.parse(sessionStorage.getItem("MI2Metrics"));
    let PARTID = sessionStorage.getItem("PARTID");
    let [loading, setLoading] = React.useState(true);
    const [isDownloading, setIsDownloading] = React.useState(false);
    let [sexpartners, setSexPartners] = React.useState(0);
    let [alcoholData, setAlcoholData] = React.useState([]);

  
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting);
        },
        {
          threshold: 0.1, // Adjust this value as needed
        }
      );
  
      if (divRef.current) {
        observer.observe(divRef.current);
      }
      

  
      return () => {
        if (divRef.current) {
          observer.unobserve(divRef.current);
        }
      };
    }, []);

    React.useEffect(() => {
        // console.log(sessionStorage.getItem('logged_in'))
        const timeout = setTimeout(() => {
            if(!sessionStorage.getItem('logged_in') || parseInt(sessionStorage.getItem('mi_metrics2_submitted')) != 1){
                history('/');
            } else {
                setSample2Data({
                    "statusCode": 200,
                    "body": {
                        "metrics": {
                            "YOUTH_SEXPARTNERS": studentResponses['YOUTH_SEXPARTNERS'],
                            "SEXACT3_SF": studentResponses['SEXACT3_SF'],
                            "SEXACT4_SF": studentResponses['SEXACT4_SF'],
                            "DrinkingBeforeSex": studentResponses['DrinkingBeforeSex'],
                            "AlcoholRelatedSexualConsequences": studentResponses['AlcoholRelatedSexualConsequences'],
                            "KNOW_HIV": studentResponses['KNOW_HIV'],
                            "RISK_FLAG": studentResponses['RISK_FLAG'],
                            "ABUSE_FLAG": studentResponses['ABUSE_FLAG'],
                            "SEXPARTNERS": studentResponses['SEXPARTNERS']
                        },
                        "student_id": PARTID
                    }
                });
                // console.log(sample2Data);
                if (studentResponses['YOUTH_SEXPARTNERS'] === 0) {
                    setSexPartners(studentResponses['SEXPARTNERS']);
                } else {
                    setSexPartners(studentResponses['YOUTH_SEXPARTNERS']);
                }

                setAlcoholData([
                    {
                      name: 'Standard Drinks before Sex (You)',
                      value: studentResponses['SEXACT4_SF'],
                      color: '#ffe29d',
                        label: 'You'
                    },
                    {
                      name: 'Standard Drinks before Sex (Avg)',
                      value: 2,
                      color: '#80b4ff',
                      label: 'Avg'
                    }
                  ]);
                setLoading(false);
    
            }
        }, 1000);
    
        // Clean-up function to clear the timeout when the component unmounts
        return () => clearTimeout(timeout);
        
      }, []);
      const InsertPDFSpace = ({ height }) =>
      isDownloading ? <div style={{ height }} /> : null;

  const downloadPage = async () => {
    setIsDownloading(true);
    await document.fonts.ready;
  
    const source = document.getElementById('metrics2');
    if (!source) {
      setIsDownloading(false);
      return;
    }
  
    // ---- 1) make an off-screen desktop clone ----
    const DESKTOP_W = 1470; // use your desktop value (you measured 1470)
    const clone = source.cloneNode(true);
    clone.id = 'metrics2-pdf-clone';
    Object.assign(clone.style, {
      width: `${DESKTOP_W}px`,
      maxWidth: 'none',
      height: 'auto',
      position: 'fixed',
      left: '-10000px',
      top: '0',
      zIndex: '-1',
      transform: 'none',
      overflow: 'visible',
      background: '#ffffff'
    });
    document.body.appendChild(clone);
  
    // ---- 2) Wait for charts to render ----
    await new Promise(resolve => setTimeout(resolve, 1000));

    // ---- 3) make sure images in the CLONE are ready ----
    const imgs = Array.from(clone.querySelectorAll('img'));
    try {
      await Promise.all(
        imgs.map(img =>
          // Safari sometimes lacks decode(); fall back to onload/complete
          img.decode ? img.decode() : (img.complete ? Promise.resolve() : new Promise(res => img.onload = res))
        )
      );
    } catch (_) {}

    // ---- 4) compute safe scale for iOS (avoid > ~16384 px canvas) ----
    const targetWidth = DESKTOP_W;
    // Add more padding for mobile devices to prevent cuts
    const isMobile = window.innerWidth <= 768;
    const extraPadding = isMobile ? 200 : 100;
    const targetHeight = clone.scrollHeight + extraPadding;
    const MAX_CANVAS = 16000;                         // conservative
    let scale = Math.min(window.devicePixelRatio || 1, 2);
    const worstSide = Math.max(targetWidth, targetHeight);
    if (worstSide * scale > MAX_CANVAS) {
      scale = Math.max(1, (MAX_CANVAS - 1) / worstSide); // keep under cap
    }
  
    // ---- 5) render the CLONE (not the live DOM) ----
    const canvas = await html2canvas(clone, {
      scale,
      useCORS: true,
      backgroundColor: '#ffffff',
      // Force desktop media queries and full height
      windowWidth: targetWidth,
      windowHeight: targetHeight,
      scrollX: 0,
      scrollY: 0,
      logging: false,
      removeContainer: true
    });
  
    // Clean up the clone
    document.body.removeChild(clone);
  
    // ---- 6) build one long-page PDF (no page breaks) ----
    const imgData = canvas.toDataURL('image/jpeg', 0.95);
    const pdfProbe = new jsPDF('p', 'mm', 'a4');
    const pdfW = pdfProbe.internal.pageSize.getWidth();
    const props = pdfProbe.getImageProperties(imgData);
    const pdfH = (props.height * pdfW) / props.width;
  
    const longPdf = new jsPDF('p', 'mm', [pdfW, pdfH]);
    longPdf.addImage(imgData, 'JPEG', 0, 0, pdfW, pdfH);
    const today = new Date();
    const dateStr = today.toISOString().split('T')[0]; // "2025-09-22"

    longPdf.save(`MIMetrics2_${PARTID}_${dateStr}.pdf`);

    
  
    setIsDownloading(false);
  };

      
      
      
      

    return (
        loading ? <div>
            <Loader />
        </div> :
        <MetricsWrap id="metrics2">
            <div style={{display: 'flex', alignItems: 'center', justifyContent:'center', flexDirection: 'column'}}>
                <div style={{backgroundColor: "#D3EEFF", height: '100px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <img style={{margin: 'auto'}} width="150px" height="60px" src={logo}></img>
                </div>
                <InsertPDFSpace height="0px" />


                <div style={{display: 'relative', margin: 'auto', }}>

                </div>
               
                {!isDownloading ? <button onClick={()=>downloadPage()} style={{color: 'blue', margin: '20px 7.5% 20px auto', display: 'flex', flexDirection: 'row', border: 'none', background:'none'}}>
                <p style={{margin: 'auto', padding: '5px'}}>Download</p>
                <img style={{marginLeft: '5px'}} width='30px' height='30px' src={downloadImg}></img>
                </button> : false}
                {/* <div style={{margin:'auto', marginTop: '40px', borderRadius:'8px', width: '90%', height: '100%'}}>
                    <img src={initialLayout} style={{width: '100%', height: '100%'}}></img>
                </div> */}
            
            <Top>
            <ResponsesText>
            
            
            <p>LET'S TAKE A BREAK TO CHAT ABOUT</p>
            <p>SOME OF THESE </p>
            </ResponsesText>
            <img width={"100%"} src={TopImage} />
            <LineDiv style={{width: '350px', marginTop: '20px', zIndex: '-1'}} />
            
            </Top>  
                <div style={{margin:'auto', marginTop: '40px', borderRadius:'8px', width: '90%', height: '100%', backgroundColor: "#D3EEFF"}}>
                {/* <HeadingText>
                  <h3>SEXUAL HEALTH test</h3>
                  <h4>POPULATION STATS AND YOU</h4>
                </HeadingText> */}
                    {/* <SexualHealthTitle>
                        SEXUAL HEALTH
                    </SexualHealthTitle> */}
                    {sexpartners > 1 && <>
                    <div style={{margin:'auto', display: 'flex', justifyContent: 'center', marginBottom: '30px', marginTop: '20px'}}>
                        <HeadingText>
                            <h3>SEXUAL HEALTH</h3>
                            <h4>POPULATION STATS AND YOU</h4>
                        </HeadingText>
                    </div>

                    <SexualHealthSectionWrap>
                        <SexualHealthTextDiv>
                            <p style={{fontWeight: '600'}}>
                                In the last 30 days, you said you had <FeedBackNumbersWithBackGround>{sexpartners}</FeedBackNumbersWithBackGround> partners.
                            </p>
                            <p style={{fontWeight: '600'}}>
                                You can compare this to people your age, who reported having <FeedBackNumbersWithBackGround>1</FeedBackNumbersWithBackGround> partner in the last 30 days on average.
                            </p>
                        </SexualHealthTextDiv>
                        
                        <GreyBoxDiv>
                            <GreyBoxImg src={GreyBox}></GreyBoxImg>  
                        </GreyBoxDiv>
                    </SexualHealthSectionWrap>

                    <SexualHealthMiniScreenWrap>
                        <SexualHealthTextDiv>
                            <p style={{fontWeight: '600'}}>
                                In the last 30 days, you said you had <FeedBackNumbersWithBackGround>{sexpartners}</FeedBackNumbersWithBackGround> partners.
                            </p>
                            <p style={{fontWeight: '600'}}>
                                You can compare this to people your age, who reported having <FeedBackNumbersWithBackGround>1</FeedBackNumbersWithBackGround> partner in the last 30 days on average.
                            </p>
                        </SexualHealthTextDiv>
                        
                        <GreyBoxDiv>
                            <GreyBoxImg src={GreyBox}></GreyBoxImg>  
                        </GreyBoxDiv>
                    </SexualHealthMiniScreenWrap>

                    <LineDiv  /> 
                    <div style={{margin: '30px auto', width: '100%', textAlign: 'center'}}>
                        {/* <h4>MYTH: Only promiscuous people contract STDs.</h4> */}
                        <img src={Myth} style={{width: '80%'}}></img>
                    </div>
                    </>
                    }

                    {/* <LineDiv style={{marginTop: '20px'}} /> */}
                    <div style={{margin:'auto', display: 'flex', justifyContent: 'center'}}>
                        <TipsHeading>The Importance of Sexual Health</TipsHeading>
                    </div>

                    <div style={{margin: '3% 5%', fontWeight: '500'}}>
                        <p>Sexual health is fundamental to the overall health and well-being of everyone! It is the ability to embrace and enjoy our sexuality throughout our lives and requires a positive and respectful approach to sexuality and sexual relationships. It is also important to have pleasurable and safe sexual experiences free of coercion, discrimination, and violence. </p>
                        <p>Being sexually healthy includes: </p>
                        <ULELEMENTS>
                            <li>respecting the sexual rights we all share</li>
                            <li>making an effort to prevent unintended pregnancies/STDs</li>
                            <li>knowing your risks and vulnerabilities to adverse consequences of unprotected sexual activity</li>
                            <li>having access to comprehensive, good-quality information about sex and sexuality</li>
                            <li>seeking care and treatment when needed</li>
                            <li>being able to communicate about your sexual health needs with your sexual partners and your healthcare providers.</li>
                            <li>living in an environment that affirms and promotes sexual health.</li>
                        </ULELEMENTS>
                    </div>
                </div>
                <InsertPDFSpace height="0px" />

                {sample2Data.body.metrics.SEXACT3_SF >= 3 &&
                <div style={{margin:'auto', marginTop: '40px', borderRadius:'8px', width: '90%', height: '100%', backgroundColor: "#D3EEFF", overflow: 'hidden'}}>
                <div style={{padding: "2%", width: "100%", overflow: 'hidden'}}>
                <div style={{marginBottom: '20px'}}>
                <HeadingText>
                  <h3>SEX AND SUBSTANCES</h3>
                  {/* <h4>POPULATION STATS AND YOU</h4> */}
                </HeadingText>
                </div>
{/* <SexualHealthTitle style={{width: '60%', marginLeft: '40px', marginTop: '40px'}}>
                        Sex and substances
                    </SexualHealthTitle> */}
                    
                    <SexAndSubstancesSectionWrap>
                        <Box>
                            <h3>NUMBER OF DRINKS BEFORE SEX</h3>
                            <BarCompHorizontalWrap width={500}>
                                <BarChartHorizontalComp
                                    barChartData={alcoholData} 
                                    bar1Key="value" 
                                    label="" 
                                    barWidth={30}
                                    showLabels={false}
                                />
                            </BarCompHorizontalWrap>
                        </Box>
                        <ChartContentDiv>
                            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-around'}}>
                                <SEXANDSUBSTANCESTEXTDIV>
                                    <p style={{fontWeight: '600'}}>You reported having an average of <FeedBackNumbersWithBackGround>{sample2Data.body.metrics.SEXACT4_SF}</FeedBackNumbersWithBackGround> drinks before sex. 
                                        In comparison, people your age who said they drank before sex reported having <FeedBackNumbersWithBackGround>2</FeedBackNumbersWithBackGround> drinks before sex on average. 
                                    </p>
                                </SEXANDSUBSTANCESTEXTDIV>
                                <SEXANDSUBSTANCESIMGDIV>
                                    <img src={LadyWithDrink} style={{width: '100%', height: 'auto',maxWidth:'220px'}}></img>
                                </SEXANDSUBSTANCESIMGDIV>
                            </div>
                            <LineDiv  style={{marginTop: '0px'}}/> 
                        </ChartContentDiv> 
                    </SexAndSubstancesSectionWrap>

                    <SexAndSubstancesMiniScreenWrap>
                        <Box style={{padding: "2% 0 0"}}>
                            <h3>NUMBER OF DRINKS BEFORE SEX</h3>
                            <BarCompHorizontalWrap width={500}>
                                <BarChartHorizontalComp
                                    barChartData={alcoholData} 
                                    bar1Key="value" 
                                    label="" 
                                    barWidth={30}
                                    showLabels={false}
                                />
                            </BarCompHorizontalWrap>
                        </Box>
                        <ChartContentDiv>
                            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                                <SEXANDSUBSTANCESTEXTDIV>
                                    <p style={{fontWeight: '600'}}>You reported having an average of <FeedBackNumbersWithBackGround>{sample2Data.body.metrics.SEXACT4_SF}</FeedBackNumbersWithBackGround> drinks before sex. 
                                        In comparison, people your age who said they drank before sex reported having <FeedBackNumbersWithBackGround>2</FeedBackNumbersWithBackGround> drinks before sex on average. 
                                    </p>
                                </SEXANDSUBSTANCESTEXTDIV>
                                <SEXANDSUBSTANCESIMGDIV>
                                    <img src={LadyWithDrink} style={{width: '100%', height: 'auto',maxWidth:'220px'}}></img>
                                </SEXANDSUBSTANCESIMGDIV>
                            </div>
                            <LineDiv  style={{marginTop: '0px'}}/> 
                        </ChartContentDiv> 
                    </SexAndSubstancesMiniScreenWrap>
                    </div>
                </div>
}
                <ContentBox>
                    <HeadingWrap>
                        <TipsHeading>
                            HIV RESOURCES
                        </TipsHeading>
                    </HeadingWrap>
                    <TipsSections>
                    <p>Do you know where to go for: HIV resources?</p>
                    {/* <ul>
                        <li>Metro Inclusive Health</li>
                        <li>Planned Parenthood</li>
                        <li>YYC</li>
                    </ul> */}
                                  <ResourcesBox>
                <h4>YYC</h4>
                <ul>                    
                  <li><img src={Phone} /><strong>Phone</strong><p>(813) 821-8955</p></li>   
                  <li><img src={Location} /><strong>Location</strong><p>1315 E7th Ave Ste 104, Tampa, FL 33605</p></li>                                                                                                                                      
                </ul>
              </ResourcesBox>  
                    <ResourcesBox>
                <h4>Metro Inclusive Health</h4>
                <ul>                 
                  <li><img src={Web} /><strong>Website</strong><p>https://www.metrotampabay.org/</p></li>
                  <li><img src={Phone} /><strong>Phone</strong><p>(813) 232-3808</p></li>       
                  <li><img src={Location} /><strong>Location</strong><p>3918 N Highland Ave, Tampa, FL 33603</p></li>                                                                                                                                       
                </ul>
              </ResourcesBox> 
              <ResourcesBox>
                <h4>Planned Parenthood</h4>
                <ul>                 
                  <li><img src={Web} /><strong>Website</strong><p>https://www.plannedparenthood.org</p></li>     
                  <li><img src={Location} /><strong>Location</strong><p>Visit website to see locations nearest to you</p></li>                                                                                                                                       
                </ul>
              </ResourcesBox> 
                    </TipsSections>
              </ContentBox>

              <ContentBox>
              <HeadingWrap>
                <TipsHeading>
                SUBSTANCE USE RESOURCES
                  </TipsHeading>
                  </HeadingWrap>
                <TipsSections>
                  <p>Do you know where to go for: Substance usage resources?</p>
                  {/* <ULELEMENTS>
                    <li>Ibis Healthcare</li>
                    <li>Phoenix House</li>
                    <li>ACTS</li>
                    <li>Tampa Metro Treatment Center</li>
                  </ULELEMENTS> */}
                               <ResourcesBox>
                <h4>Ibis Healthcare</h4>
                <ul>                 
                  <li><img src={Web} /><strong>Website</strong><p>https://ibishealth.org/</p></li>
                  <li><img src={Phone} /><strong>Phone</strong><p>(813) 384-4000</p></li>       
                  <li><img src={Location} /><strong>Location</strong><p>4422 East Columbus Drive, Tampa, FL 33605</p></li>                                                                                                                                       
                </ul>
              </ResourcesBox> 
              <ResourcesBox>
                <h4>Phoenix House</h4>
                <ul>                 
                  <li><img src={Web} /><strong>Website</strong><p>https://www.phoenixfl.org</p></li>
                  <li><img src={Phone} /><strong>Phone</strong><p>(813) 881-1000</p></li>       
                  <li><img src={Location} /><strong>Location</strong><p>Visit website to see locations nearest to you</p></li>                                                                                                                                       
                </ul>
              </ResourcesBox> 
                               <ResourcesBox>
                <h4>Agency for Community Treatment Services (ACTS)</h4>
                <ul>                 
                  <li><img src={Phone} /><strong>Phone</strong><p>(813) 246-4899</p></li>       
                  <li><img src={Location} /><strong>Location</strong><p>3450 Buschwood Park Dr., Suite 345, Tampa, FL 33618</p></li>                                                                                                                                       
                </ul>
              </ResourcesBox> 
              <ResourcesBox>
                <h4>New Season Treatment Center</h4>
                <ul>                 
                  <li><img src={Phone} /><strong>Phone</strong><p>(877) 284-7074</p></li>       
                  <li><img src={Location} /><strong>Location</strong><p>7207 & 7225 North Nebraska Ave, Tampa, FL 33604</p></li>                                                                                                                                       
                </ul>
              </ResourcesBox> 
                  </TipsSections>
              </ContentBox>

              {sample2Data.body.metrics.ABUSE_FLAG == 1 ? <ContentBox>
              <HeadingWrap>
                <TipsHeading>
                DOMESTIC AND PERSONAL VIOLENCE RESOURCES
                  </TipsHeading>
                  </HeadingWrap>
                <TipsSections>
                  <p>Do you know where to go for: Domestic and Personal Violence resources?</p>
                  {/* <ULELEMENTS>
                    <li>The Crisis Center of Tampa Bay</li>
                    <li>The Spring of Tampa Bay</li>
                  </ULELEMENTS> */}
                  <SOSSection>
                    <img src={SOSIcon} />
                    <div>
                  <p><strong>In case of emergency call:</strong> 9-1-1</p>
                  <p><strong>Florida Domestic Violence Hotline:</strong> (800) 500-1119</p>
                  </div>
                  </SOSSection>
                               <ResourcesBox>
                <h4>The Crisis Center of Tampa Bay</h4>
                <ul>                 
                  <li><img src={Web} /><strong>Website</strong><p>https://www.crisiscenter.com</p></li>
                  <li><img src={Phone} /><strong>Phone (In Hillsborough County)</strong><p>2-1-1</p></li>       
                  <li><img src={Phone} /><strong>Phone (Outside of Hillsborough County)</strong><p>(813) 234-1234</p></li>                                                                                                                                       
                </ul>
              </ResourcesBox> 
              <ResourcesBox>
                <h4>The Spring of Tampa Bay</h4>
                <ul>                 
                  <li><img src={Web} /><strong>Website</strong><p>https://www.thespring.org</p></li>
                  <li><img src={Phone} /><strong>24-hour Crisis Hotline Call/Text:</strong><p>(813) 247-7233</p></li>                                                                                                                                            
                </ul>
              </ResourcesBox> 
                  </TipsSections>
              </ContentBox> : null}
              {/* <div style={{display: 'flex', justifyContent: '', marginTop: '30px', width: '100%'}}> */}
                {/* <img src={LastPage} style={{width: '100%', height: '100%'}}></img> */}
                {/* <Top>
            <ResponsesText>
            <p>YOU HAVE ARRIVED AT YOUR DESTINATION</p>
            </ResponsesText>
            <img src={EndImage} width={"100%"} />
                <img  className={`car ${isVisible ? "animate" : ""}`} ref={divRef} src={Car} />
            </Top>   */}
                <EndImageDiv>
                    <div style={{display: "flex", justifyContent: "center"}}>
                    <div style={{width: "60%"}}>
                <ResponsesText>
            <p>YOU HAVE ARRIVED AT YOUR DESTINATION</p>
            </ResponsesText>
            </div>
            </div>
                <img src={EndImage} width={"100%"} />
                <img  className={`car ${isVisible ? "animate" : ""}`} ref={divRef} src={Car} />
                </EndImageDiv>
            {/* </div>     */}
            </div>
        </MetricsWrap>
    )
}

/* ================== STYLES FOR MIMetrics2 ================== */

const MetricsWrap = styled.article`
  display: flex;
  flex-direction: column;
  background-image: url(${YouthBg});
  background-size: 650px 300px;
  background-position: center;
  width: 100%; 
  word-wrap: break-word;

  p {
    font-size: 20px;
    word-wrap: break-word;
  }

  @media only screen and (max-width: 780px) {
    background-size: 100%;
    p {
      font-size: 16px;
      margin: 0;
    }
  }

  @media only screen and (max-width: 550px) {
    p {
      font-size: 14px;
      margin: 0;
      line-height: 19px;
    }
  }
`;

// Removed ChatBox - no longer needed


const Top = styled.section`
  width: 90%;
  background-color: #d3edff;
  color: white;
  padding: 2% 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  img { margin-top: 1%; }

  @media only screen and (max-width: 550px) {
    h3 { font-size: 12px !important; }
    p { font-size: 14px !important; }
  }
`;

const EndImageDiv = styled.section`
  position: relative;
  width: 90%;
  padding: 2% 0 0;
  background-color: #d3edff;
  margin-top: 1.5%;

  @keyframes car-animation {
    0% { right: -2%; }
    100% { right: 20%; rotate: 20deg; top: 35%; }
  }

  .car {
    position: absolute;
    width: 25%;
    right: -2%;
    top: 45%;
  }
  .animate {
    animation-name: car-animation;
    animation-duration: 4s;
    animation-fill-mode: forwards;
  }

  @media only screen and (max-width: 550px) {
    h3 { font-size: 12px !important; }
    p { font-size: 14px !important; }
  }
`;

const ResponsesText = styled.div`
  padding: 1% 2%;
  background: linear-gradient(90deg, rgba(204,254,216,1) 0%, rgba(148,185,255,1) 100%);
  border: 1px solid black;
  border-radius: 50px;
  color: #3e3e3e;
  font-size: 40px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    text-align: center;
    margin: 0;
    font-size: 40px;
  }

  @media only screen and (min-width: 550px) and (max-width: 1024px) {
    font-size: 30px;
    padding: 3%;
    p { font-size: 30px !important; }
  }
`;

// Removed ChatImg - no longer needed

const BarCompHorizontalWrap = styled.div`
  width: ${props => props.width ? `${props.width}px` : '100%'};
  height: ${props => props.height ? `${props.height}px` : '280px'};
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  overflow: visible;
  padding: 10px 0;

  @media (max-width: 1024px) {
    height: 240px;
    width: 100%;
    max-width: 90%;
    padding: 15px 10px;
    box-sizing: border-box;
  }

  @media (max-width: 768px) {
    height: 220px;
    width: 100%;
    max-width: 95%;
    padding: 10px 5px;
    box-sizing: border-box;
  }

  @media (max-width: 550px) {
    height: 200px;
    width: 100%;
    max-width: 98%;
    padding: 8px 0;
    margin-bottom: 10px;
    box-sizing: border-box;
  }
`;

const Box = styled.section`
  background-color: white;
  padding: 25px 20px 20px 20px;
  border-radius: 25px;
  border: 1px solid black;
  text-align: center;
  margin-right: 20px; 
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60%;
  max-width: 60%;
  overflow: hidden;
  box-sizing: border-box;

  h3 {
    margin: 20px 0 15px 0;
    font-size: 18px;
  }

  @media only screen and (max-width: 1024px) {
    margin-right: unset;
    margin: 0 auto 20px auto;
    padding: 20px 15px 15px 15px;
    width: 100%;
    max-width: 90%;
    margin-top: 20px; /* Add space above chart */
    overflow: hidden;
    box-sizing: border-box;
    h3 {
      font-size: 16px;
      margin: 20px 0 15px 0;
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 18px 12px 12px 12px;
    margin-top: 15px; /* Add space above chart */
    width: 100%;
    max-width: 95%;
    overflow: hidden;
    box-sizing: border-box;
    h3 {
      font-size: 14px;
      margin: 18px 0 12px 0;
    }
  }

  @media only screen and (max-width: 550px) {
    padding: 15px 10px 10px 10px;
    margin-top: 10px;
    width: 100%;
    max-width: 98%;
    overflow: hidden;
    box-sizing: border-box;
    h3 {
      font-size: 12px;
      margin: 15px 0 10px 0;
    }
  }
`;

// Removed TextInsideChat - no longer needed


// Removed PersonImgDiv and PersonImg - no longer needed

const HeadingText = styled.div`
  width: ${(props) => props.width ? props.width : 400}px;
  background: linear-gradient(90deg, rgba(204,254,216,1) 0%, rgba(148,185,255,1) 100%);
  border: 1px solid black;
  padding: 5px 20px;
  color: #3e3e3e;
  border-radius: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h3 { font-size: 35px; margin: 5px 0; }
  h4 { font-size: 20px; margin: 5px 0; }

  @media only screen and (max-width: 550px) {
    width: ${(props) => props.width ? props.width : 45}%;
    h3 { font-size: 14px; margin: 0; }
    h4 { font-size: 10px; margin: 0; }
  }

  @media only screen and (min-width: 550px) and (max-width: 1024px) {
    width: ${(props) => props.width ? props.width : 260}px;
    h3 { font-size: 22px; margin: 0; }
    h4 { font-size: 16px; margin: 0; }
  }
`;

const SexualHealthTitle = styled.div`
  font-size: 24px;
  width: 40%;
  margin: auto;
  font-weight: bold;
  color: black;
  text-align: center;
  margin-top: 20px;
  margin-right: 10%;
  background: linear-gradient(90deg, #cdffb8, #94b9ff);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  border: 1px solid black;
  height: 60px;

  @media only screen and (max-width: 780px) { font-size: 20px; }
  @media only screen and (max-width: 550px) { font-size: 18px; height: 40px; }
`;

const LineDiv = styled.div`
  border: 0.5px solid black;
  height: 0px;
  width: 95%;
  margin: auto;
  position: relative;
  z-index: 1;
`;

// Removed SexualHealthFlexBox - replaced with responsive SexualHealthSectionWrap and SexualHealthMiniScreenWrap

/* Keep going for GreyBoxDiv, GreyBoxImg, ContentBox, TipsHeading, etc.
   → Add `@media only screen and (min-width: 550px) and (max-width: 1024px)`
   rules just like in MI1 for font-size scaling and widths. */

   const GreyBoxDiv = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   width: 40%;
   box-sizing: border-box;
   max-width: 100%;
 
   @media only screen and (max-width: 1024px) {
     width: 100%;
     margin-top: 0;
     max-width: 100%;
   }
   @media only screen and (max-width: 768px) {
     width: 100%;
     margin-top: 0;
     max-width: 100%;
   }
   @media only screen and (max-width: 550px) {
     width: 100%;
     margin-top: 0;
     max-width: 100%;
   }
 `;
 
 const GreyBoxImg = styled.img`
   width: 100%;
   height: 260px;
   margin: auto;
   max-width: 100%;
   object-fit: contain;
 
   @media only screen and (max-width: 1024px) {
     height: 200px;
     max-width: 100%;
   }
   @media only screen and (max-width: 768px) {
     height: 180px;
     max-width: 100%;
   }
   @media only screen and (max-width: 550px) {
     height: 160px;
     max-width: 100%;
   }
 `;
 
 const GreyBoxText = styled.div`
   position: absolute;
   top: 20%;
   left: 14%;
   width: 70%;
   font-size: 18px;
   color: black;
   text-align: center;
 
   @media only screen and (max-width: 780px) {
     font-size: 14px;
   }
   @media only screen and (max-width: 550px) {
     font-size: 11px;
   }
   @media only screen and (min-width: 550px) and (max-width: 1024px) {
     font-size: 16px;
   }
 `;
 
 const ContentBox = styled.section`
   background-color: #D3EEFF;
   border-radius: 5px;
   font-size: 20px;
   margin: 1.5% 0 0;
   width: 90%;
 
   section { margin: 2%; }
 
   h4 { margin: 0; }
 
   @media only screen and (max-width: 780px) {
     ul { font-size: 16px; }
   }
   @media only screen and (max-width: 550px) {
     ul { font-size: 14px; }
   }
   @media only screen and (min-width: 550px) and (max-width: 1024px) {
     font-size: 18px;
     ul { font-size: 15px; }
   }
 `;
 
 const TipsHeading = styled.span`
   background-color: #ffd42a;
   border-radius: 10px;
   padding: 10px;
   font-size: 27px;
   font-weight: bold;
   text-align: center;
   margin-top: 1%;
 
   @media only screen and (max-width: 780px) {
     font-size: 20px;
   }
   @media only screen and (max-width: 550px) {
     font-size: 14px;
   }
   @media only screen and (min-width: 550px) and (max-width: 1024px) {
     font-size: 22px;
   }
 `;
 
 const HeadingWrap = styled.section`
   display: flex;
   justify-content: center;
   margin: 25px;
 
   @media only screen and (min-width: 550px) and (max-width: 1024px) {
     margin: 15px;
   }
 `;
 
 const ChartDiv = styled.div`
   width: 40%;
   padding: 20px;
   font-weight: 600;
   margin: 20px;
   border: 1px solid black;
   background: white;
   border-radius: 20px;
 
   @media only screen and (max-width: 780px) {
     width: 40%;
   }
   @media only screen and (max-width: 550px) {
     width: auto;
     margin: 40px 10px 30px;
   }
   @media only screen and (min-width: 550px) and (max-width: 1024px) {
     width: 60%;
     margin: 20px auto;
   }
 `;
 
 const PoleDiv = styled.div`
   width: 20%;
   margin-top: 60px;
   margin-right: 100px;
 
   @media only screen and (max-width: 780px) {
     margin-right: 50px;
   }
   @media only screen and (max-width: 550px) {
     margin-right: 10px;
   }
   @media only screen and (min-width: 550px) and (max-width: 1024px) {
     margin-right: 30px;
   }
 `;
 
 const ULELEMENTS = styled.ul`
   font-size: 20px;
 
   @media only screen and (max-width: 780px) {
     font-size: 16px;
   }
   @media only screen and (max-width: 550px) {
     font-size: 14px;
   }
   @media only screen and (min-width: 550px) and (max-width: 1024px) {
     font-size: 17px;
   }
 `;
 
// Removed CHATBOXANDPERSONDIV - no longer needed

 
const SEXANDSUBSTANCESTEXTDIV = styled.div`
  width: 50%;
  padding: 20px;
  font-weight: 600;
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;

  p { 
    font-size: 22px; 
    margin: 10px 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media only screen and (max-width: 1024px) {
    width: 100%;
    margin: 20px auto;
    padding: 15px;
    max-width: 100%;
    p { 
      font-size: 18px; 
      margin: 8px 0;
    }
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
    margin: 15px auto;
    padding: 12px;
    max-width: 100%;
    p { 
      font-size: 16px; 
      margin: 6px 0;
    }
  }
  @media only screen and (max-width: 550px) {
    width: 100%;
    margin: 10px auto;
    padding: 8px;
    max-width: 100%;
    p { 
      font-size: 14px; 
      margin: 4px 0;
      line-height: 1.4;
    }
  }
`;
 
 const SEXANDSUBSTANCESIMGDIV = styled.div`
  width: 28%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  @media only screen and (max-width: 1024px) {
    width: 50%;
    margin-top: 20px;
  }

  @media only screen and (max-width: 768px) {
    width: 60%;
    margin-top: 15px;
  }

  @media only screen and (max-width: 550px) {
    width: 70%;
    margin-top: 10px;
  }
`;

 
 const TipsSections = styled.section`
   font-weight: 500;
 
   @media only screen and (max-width: 780px) {
     p { font-size: 16px; }
     ul { font-size: 16px; }
   }
   @media only screen and (max-width: 550px) {
     p { font-size: 13px; }
     ul { font-size: 12px; }
   }
   @media only screen and (min-width: 550px) and (max-width: 1024px) {
     p { font-size: 15px; }
     ul { font-size: 15px; }
   }
 `;
 
 const FeedBackNumbers = styled.span`
   font-weight: 900;
   font-size: 28px;
   color: #0885ff;
   border-radius: 10px;
   padding: 2px 5px;
 
   @media only screen and (max-width: 780px) {
     font-size: 22px;
     padding: 2px 10px;
   }
   @media only screen and (max-width: 550px) {
     font-size: 18px;
     padding: 2px 8px;
   }
   @media only screen and (min-width: 550px) and (max-width: 1024px) {
     font-size: 20px;
     padding: 2px 10px;
   }
 `;
 
 const FeedBackNumbersWithBackGround = styled.span`
   font-weight: 900;
   font-size: 24px;
   color: black;
   border: 1px solid black;
   background-color: white;
   border-radius: 10px;
   padding: 2px 15px;
 
   @media only screen and (max-width: 780px) {
     font-size: 20px;
     padding: 2px 10px;
   }
   @media only screen and (max-width: 550px) {
     font-size: 18px;
     padding: 2px 8px;
     margin-top: 2px;
   }
   @media only screen and (min-width: 550px) and (max-width: 1024px) {
     font-size: 20px;
     padding: 2px 10px;
   }
 `;
 
 const ChartContentDiv = styled.div`
   width: 60%;
   align-content: center;
   box-sizing: border-box;
   overflow: hidden;

   @media only screen and (max-width: 1024px) {
     width: 100%;
     margin: auto;
     box-sizing: border-box;
     overflow: hidden;
   }
   @media only screen and (max-width: 768px) {
     width: 100%;
     margin: auto;
     box-sizing: border-box;
     overflow: hidden;
   }
   @media only screen and (max-width: 550px) {
     width: 100%;
     margin: auto;
     box-sizing: border-box;
     overflow: hidden;
   }
 `;
 
// Removed ChartBoxSexualContentDiv - replaced with responsive SexAndSubstancesSectionWrap and SexAndSubstancesMiniScreenWrap
 
 const ResourcesBox = styled.section`
   border: solid 2px #5e5e60;
   border-radius: 10px;
   margin-top: 20px;
 
   h4 {
     background-color: #025dc7;
     margin: 0;
     padding: 10px 15px;
     color: #ffffff;
     border-radius: 8px 8px 0 0;
     border-bottom: 2px solid #5e5e60;
   }
 
  li {
    display: flex;
    align-items: center;
    color: #025dc7;
    img { 
      width: 25px; 
      height: 25px; 
      margin-right: 10px; 
      display: block;
      object-fit: contain;
      flex-shrink: 0;
    }
    strong { min-width: 15%; margin-right: 2%; }
    p { margin: 0; color: #5e5e60; }
  }
 
  @media only screen and (max-width: 550px) {
    h4 { font-size: 13px; padding: 2%; }
    ul { padding: 0; margin: 2%; }
    li img { 
      width: 15px; 
      height: 15px; 
      display: block;
      object-fit: contain;
      flex-shrink: 0;
    }
  }
  @media only screen and (min-width: 550px) and (max-width: 1024px) {
    h4 { font-size: 15px; }
    li img { 
      width: 18px; 
      height: 18px; 
      display: block;
      object-fit: contain;
      flex-shrink: 0;
    }
  }
 `;
 
const SOSSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  img { 
    margin-right: 1%; 
    width: 30px;
    height: 30px;
    display: block;
    object-fit: contain;
    flex-shrink: 0;
  }
  
  @media only screen and (max-width: 550px) {
    img { 
      width: 25px; 
      height: 25px; 
    }
  }
  
  @media only screen and (min-width: 550px) and (max-width: 1024px) {
    img { 
      width: 28px; 
      height: 28px; 
    }
  }
`; 

const SexualHealthSectionWrap = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  padding: 20px;

  @media (max-width: 1024px) {
    display: none; /* hide on tablet and mobile, show only on desktop */
  }
`;

const SexualHealthMiniScreenWrap = styled.section`
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;

  @media only screen and (max-width: 1024px) {
    display: flex;
    padding: 20px 15px;
    margin-bottom: 20px;
    width: 100%;
    max-width: 100%;
  }

  @media only screen and (max-width: 768px) {
    display: flex;
    padding: 15px 10px;
    margin-bottom: 20px;
    width: 100%;
    max-width: 100%;
  }

  @media only screen and (max-width: 550px) {
    display: flex;
    padding: 10px 5px;
    margin-bottom: 15px;
    width: 100%;
    max-width: 100%;
  }
`;

const SexAndSubstancesSectionWrap = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  @media (max-width: 1024px) {
    display: none; /* hide on tablet and mobile, show only on desktop */
  }
`;

const SexAndSubstancesMiniScreenWrap = styled.section`
  display: none;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  @media only screen and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 15px;
    margin-bottom: 20px;
    width: 100%;
    max-width: 100%;
  }

  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 10px;
    margin-bottom: 20px;
    width: 100%;
    max-width: 100%;
  }

  @media only screen and (max-width: 550px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 5px;
    margin-bottom: 15px;
    width: 100%;
    max-width: 100%;
  }
`;

const SexualHealthTextDiv = styled.div`
  width: 60%;
  padding: 20px;
  font-weight: 600;
  text-align: center;
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;
  
  p { 
    font-size: 22px;
    line-height: 1.4;
    margin: 10px 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media only screen and (max-width: 1024px) {
    width: 100%;
    margin: 0;
    padding: 15px;
    max-width: 100%;
    p { 
      font-size: 18px;
      margin: 8px 0;
    }
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
    margin: 0;
    padding: 10px;
    max-width: 100%;
    p { 
      font-size: 16px;
      margin: 6px 0;
    }
  }
  @media only screen and (max-width: 550px) {
    width: 100%;
    margin: 0;
    padding: 5px;
    max-width: 100%;
    p { 
      font-size: 14px;
      margin: 4px 0;
    }
  }
`;


export default MIMetrics2;